import { render, staticRenderFns } from "./MileageFuel.vue?vue&type=template&id=056cafc1&lang=pug"
import script from "./MileageFuel.vue?vue&type=script&lang=js"
export * from "./MileageFuel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports